import { Gesture, SwipeDirection } from 'config'
import { BaseModel } from './base.model'
import { InteractiveContentItemTransitionSkill } from './interactive-content-item-transition-skill.model'

export class InteractiveContentItemTransition extends BaseModel<InteractiveContentItemTransition> {
  static DEFAULT_ATTRIBUTES = {
    transitionSkills: new Array<InteractiveContentItemTransitionSkill>()
  }

  _destroy: boolean
  id: number
  name: string
  itemId: number
  nextItemId: number
  timeout: number
  comment: string
  orderNumber: number
  gesture: Gesture
  swipeDirection: SwipeDirection
  startTime: number
  endTime: number
  leftX: number
  leftY: number
  rightX: number
  rightY: number
  transitionSkills: InteractiveContentItemTransitionSkill[]
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/interactive-content-item-transition.model.ts